import styled from "styled-components";

export const CareersStyleWrapper = styled.div`
   /* css for careers list */
   .accordion-item {
      background: #0e0e0e;
      border: none;
      border-radius: 0px;
      box-shadow: none;
   }
   .accordion-header {
      border-bottom: 1px solid white;
      cursor: pointer;
   }
`;
